import React, { useEffect, useState } from "react";
import { Line, Bar, HorizontalBar } from "react-chartjs-2";
import "./mainDashboard.css";
import { Progress } from "antd";
import { DatePicker } from "antd";
import moment from "moment";
import NewLoader from "../../components/styled-components/loader/NewLoader";
export const DashboardSavingSection = ({
  expenseData,
  loading,
  getAllExpanse,
  getAllTopExpanse,
}) => {
  const { MonthPicker } = DatePicker;
  const [labelDates, setLabelDates] = useState([]);
  const [labelExpenses, setLabelExpenses] = useState([]);
  // Utility function to fill missing dates with zero expenses
  const fillMissingDates = (data) => {
    if (!data || data.length === 0)
      return { filledExpenses: [], filledDates: [] };

    // Get the month and year from the first date in the data
    const firstDate = moment(data[0].date);
    const year = firstDate.year();
    const month = firstDate.month() + 1; // moment months are 0-indexed

    const daysInMonth = moment(`${year}-${month}`, "YYYY-MM").daysInMonth();
    const allDates = Array.from({ length: daysInMonth }, (_, i) =>
      moment(`${year}-${month}-${i + 1}`, "YYYY-MM-DD").format("YYYY-MM-DD")
    );

    const expenseMap = data.reduce((acc, { date, totalExpenses }) => {
      acc[date] = totalExpenses;
      return acc;
    }, {});

    const filledExpenses = allDates.map((date) => ({
      date,
      totalExpenses: expenseMap[date] || 0,
    }));

    return { filledExpenses, filledDates: allDates };
  };

  // Update chart data whenever expenseData changes
  useEffect(() => {
    if (expenseData && expenseData.length > 0) {
      const { filledExpenses, filledDates } = fillMissingDates(expenseData);

      const labels = filledExpenses.map((entry) =>
        moment(entry.date).format("DD")
      );
      const expenses = filledExpenses.map((entry) => entry.totalExpenses);
      setLabelExpenses(expenses);

      // Set filled dates for any other use
      setLabelDates(filledDates);
      // console.log("expansewith dates", expenses, filledDates);
    }
  }, [expenseData]);
  const handleMonthChange = (date, dateString) => {
    if (date) {
      const startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the month
      const endDate = date.endOf("month").format("YYYY-MM-DD");
      console.log("Start Date of the Month:", startDate);
      console.log("End Date of the Month:", endDate);
      // resetState();
      // getAllExpanse(startDate, endDate);
      fetchExpanseData(startDate, endDate);
    }
  };
  const fetchExpanseData = async (startDate, endDate) => {
    await getAllTopExpanse(startDate, endDate);
    await getAllExpanse(startDate, endDate);
  };
  const data = {
    labels: labelDates && labelDates,
    datasets: [
      {
        label: "Expenses",
        data: labelExpenses && labelExpenses,
        fill: false,
        backgroundColor: "#E6F1FF",
        borderColor: "red",
      },
      {
        label: "Savings",
        data: [
          33, 53, 85, 41, 44, 65, 33, 53, 85, 41, 44, 65, 33, 53, 85, 41, 44,
          65, 33, 53, 85, 41, 44, 65, 33, 53, 85, 41, 44, 65,
        ],
        fill: false,
        backgroundColor: "#E6F1FF",
        borderColor: "#2A3DA3",
      },
    ],
  };

  return (
    <div
      className="SavingMainCard1"
      style={{
        position: "relative",
        width: "100%",
        padding: "0px",
        borderRadius: "0px",
      }}
    >
      <div className="filterWithName">
        <h1 className="SavingCardheading">Income vs Expenses</h1>
        <div className="compareSelectContainer">
          <span className="mainfilterHeading">Apply Filter: </span>
          <MonthPicker
            className="monthPickerStyle1"
            style={{
              width: "180px",
              border: "1px solid #2a3da3",
              height: "36px",
            }}
            onChange={handleMonthChange}
            format="MMMM YYYY"
            placeholder="Select month"
          />
        </div>
      </div>
      <div style={{ marginTop: "1rem", display: "flex" }}>
        <Line
          data={data}
          options={{
            legend: {
              display: true,
            },
            scales: {
              xAxes: [
                {
                  gridLines: {
                    color: "rgba(0, 0, 0, 0)",
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    callback: function (value) {
                      return new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(value);
                    },
                  },
                  // gridLines: {
                  //   color: "rgba(0, 0, 0, 0)",
                  // },
                },
              ],
            },
            plugins: {},
          }}
        />
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
